import { combineReducers } from 'redux';
import templatesStore from './templates';
import imagesStore from './images';
import groupsStore from './groups';
import categoryStore from './categories';
import alertsStore from './alerts';
import userStore from './user';

export const rootReducer = combineReducers({
  templatesStore,
  imagesStore,
  groupsStore,
  alertsStore,
  userStore,
});

export const categoryReducer = combineReducers({ categoryStore });
